import client from './client';

export const getSimpleProjectList = async () => {
  const response = await client.get('/project/list-simple');
  return response.data;
};
